<template>
  <div>
    <v-card class="pa-5 mb-5 elevation-hb">
      <v-row style="align-items: center">
        <v-col>
          <h3>Regras de Acesso</h3>
        </v-col>
        <v-col class="text-right">
          <v-btn @click="changeEditMode()" v-permission="'rule'" color="blue-grey lighten-1" depressed dark>
            <v-icon>mdi-plus</v-icon> Adicionar
          </v-btn>
        </v-col>
        <v-col cols="2">
          <v-text-field
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            outlined
            color="primary"
            v-model="search"
            dense
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="pa-5 mb-5 elevation-hb">
      <v-data-table :headers="headers" :items="rules" :search="search" :loading="loading" :items-per-page="15" danse groupBy="descRule">
        <template v-slot:[`item.action`]="{ item }">
          <v-icon class="ma-1" @click="editRule(item)">mdi-pencil</v-icon>
          <v-icon class="ma-1" @click="deleteRule(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="700px">
      <HubbleDialog icon :title="formTitle" :dialog="dialog">
        <template v-slot:body>
          <v-form ref="form" v-model="valid">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="rule.idRule"
                    label="ID da regra"
                    :disabled="editing"
                    color="primary"
                    :rules="validate.name"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="rule.descRule"
                    label="Descrição da regra"
                    color="primary"
                    required
                    outlined
                    :rules="validate.desc"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="rule.restResource"
                    label="REST"
                    color="primary"
                    :rules="validate.rest"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="rule.restMethod"
                    :items="methods"
                    label="METHOD"
                    color="primary"
                    :rules="validate.method"
                    required
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="rule.restOperation"
                    :rules="validate.operation"
                    label="OPERATION"
                    color="primary"
                    required
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="rule.permissionType"
                    :items="permType"
                    hint="1 - Allow, 2 - Decline"
                    persistent-hint
                    label="Tipo de Permissão"
                    :rules="validate.permission"
                    color="primary"
                    required
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-select
                    v-model="rule.idMenu"
                    :items="menus"
                    item-text="nameMenu"
                    item-value="idMenu"
                    label="Menus"
                    color="primary"
                    outlined
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-autocomplete
                    v-model="rule.groups"
                    :items="groups"
                    item-text="descGrp"
                    item-value="idGrp"
                    label="Grupos de acesso"
                    color="primary"
                    multiple
                    outlined
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </template>
        <template v-slot:dialogButtons>
          <v-btn icon @click="dialog = false" small>
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </template>
        <template v-slot:actions>
          <v-btn color="primary" depressed dark @click="reset">Reset</v-btn>
          <div class="flex-grow-1"></div>
          <v-btn color="primary" :disabled="!valid" depressed @click="saveRule" v-show="!editing">Save</v-btn>
          <v-btn color="primary" :disabled="!valid" depressed @click="saveEditedRule" v-show="editing">Alterar</v-btn>
        </template>
      </HubbleDialog>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'
import HubbleDialog from '@/components/HubbleDialog'

export default {
  name: 'Rules',
  components: { HubbleDialog },
  data: () => ({
    loading: false,
    dialog: false,
    valid: false,
    match: null,
    menu: false,
    search: '',
    editing: false,
    rule: {},
    rules: [],
    groups: [],
    headers: [
      { text: 'ID', value: 'idRule' },
      { text: 'Descrição', value: 'descRule' },
      { text: 'Resource', value: 'restResource' },
      { text: 'Method', value: 'restMethod' },
      { text: 'Operation', value: 'restOperation' },
      { text: 'Tipo', value: 'permissionType' },
      { text: 'Ações', value: 'action', sortable: false },
    ],
    methods: ['ALL', 'GET', 'POST', 'PUT', 'PATCH', 'DELETE'],
    validate: {
      name: [
        (v) => !!v || 'ID é obrigatório!',
        (v) => (v && v.length <= 100) || 'ID não pode ter mais de 100 caracteres!',
        (v) => /^[a-z]+[-]*[a-z]*$/.test(v) || 'Apenas letras minúsculas e "-" são permitidos no ID',
      ],
      desc: [(v) => !!v || 'Descrição obrigatória'],
      rest: [(v) => !!v || 'Rest obrigatória'],
      operation: [(v) => !!v || 'Operation obrigatória'],
      method: [(v) => !!v || 'Method obrigatório'],
      permission: [(v) => !!v || 'Permissão obrigatória'],
    },
    permType: [1, 2],
    menus: [],
  }),
  computed: {
    formTitle() {
      return this.editing == false ? 'Adicionar Regra' : 'Editar Regra'
    },
  },
  methods: {
    loadRules() {
      this.loading = true
      const url = `${baseApiUrl}/rule`
      axios
        .get(url)
        .then((res) => {
          this.rules = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    loadGroups() {
      const url = `${baseApiUrl}/grp`
      axios
        .get(url)
        .then((res) => {
          this.groups = res.data
        })
        .catch(showError)
    },
    loadMenus() {
      const url = `${baseApiUrl}/menu`
      axios
        .get(url)
        .then((res) => {
          this.menus = res.data
        })
        .catch(showError)
    },
    validateField() {
      this.$refs.form.validate()
    },
    reset() {
      this.$refs.form.reset()
    },
    changeEditMode() {
      this.rule = {}
      this.editing = false
      this.dialog = true
    },
    saveRule() {
      const url = `${baseApiUrl}/rule`

      axios
        .post(url, this.rule)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadRules()
          this.reset()
          this.dialog = false
        })
        .catch(showError)
    },
    saveEditedRule() {
      const url = `${baseApiUrl}/rule/${this.rule.idRule}`

      axios
        .put(url, this.rule)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadRules()
          this.reset()
          this.editing = false
          this.dialog = false
        })
        .catch(showError)
    },
    editRule(rule) {
      this.editing = true
      this.rule = Object.assign({}, rule)

      const url = `${baseApiUrl}/rule/${this.rule.idRule}/grp`
      axios
        .get(url)
        .then((data) => {
          this.rule.groups = data.data.map((data) => data.idGrp)
          this.dialog = true
        })
        .catch(showError)
    },
    deleteRule(rule) {
      const url = `${baseApiUrl}/rule/${rule.idRule}`
      if (confirm('Tem certeza que deseja apagar esta regra?')) {
        axios
          .delete(url)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.loadRules()
          })
          .catch(showError)
      }
    },
  },
  async mounted() {
    await Promise.all([this.loadRules(), this.loadGroups(), this.loadMenus()])
  },
}
</script>
